module.exports = __webpack_public_path__ + "static/media/hero-desktop.7330cec1.jpg";